"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var GalleryComponent =
/*#__PURE__*/
function () {
  function GalleryComponent() {
    _classCallCheck(this, GalleryComponent);

    this._gallery = $('.collage');
    this.init();
  }

  _createClass(GalleryComponent, [{
    key: "init",
    value: function init() {
      var _this = this;

      window.onload = function (e) {
        _this.reInitGallery();
      };

      window.onresize = function (e) {
        _this.reInitGallery();
      };
    }
  }, {
    key: "reInitGallery",
    value: function reInitGallery() {
      this._gallery.removeWhitespace().collagePlus({
        "targetHeight": 250,
        'allowPartialLastRow': true
      });
    }
  }]);

  return GalleryComponent;
}();